import { BLACK, WHITE } from "@styles/colors";
import { INTER } from "@styles/fonts";
import styled, { css } from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: ${BLACK};
`;

export const ScannerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  position: relative;
  overflow-y: auto;
`;

export const BlackBackgroundDiv = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  background-color: black;
`;

export const BlackSpacerDiv = styled.div`
  display: flex;
  height: 50%;
  width: 100%;
  background-color: black;
`;

export const ScannerContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: relative;
`;

export const ScannerFrame = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70vw;
  height: 70vw;
  aspect-ratio: 1;
  border: 1px solid white;
  border-radius: 32px;
`;

export const BottomActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: absolute;
  bottom: -100px;
  gap: 16px;
`;

export const ScanningText = styled.span`
  font-family: ${INTER.regular};
  color: ${WHITE};
  text-align: center;
`;

export const QRButton = styled.span<{ $isActive: boolean }>`
  text-align: center;
  border-radius: 32px;
  padding: 10px 14px;
  color: ${WHITE};
  background-color: rgba(255, 255, 255, 0.13);
  cursor: pointer;
  transition: all 0.05s ease;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  
  ${props => props.$isActive && css`
    background-color: rgba(255, 255, 255, 0.27);
    transform: scale(0.95);
  `}
`;
